import { AuthenticationContext } from 'react-adal'

// based on environment azure ad integration will be required or not
let requiresAdal = process.env.REACT_APP_USE_ADAL === 'true'

let apiUrl = process.env.REACT_APP_INTERNAL_API_HOST
let clientId = process.env.REACT_APP_AZURE_CLIENT_ID
let tenantId = process.env.REACT_APP_AZURE_TENANT_ID

// map the api being accessed to the client id of the app in azure to handle CORS requests
// https://github.com/AzureAD/azure-activedirectory-library-for-js/wiki/CORS-usage
let endpoints = {}
endpoints[apiUrl] = clientId

export const adalConfig = {
  tenant: tenantId, //  The ID or domain name of the Azure AD tenant used for authentication
  clientId: clientId, // The application ID assigned to your app by Azure AD during registration.
  endpoints
}

export const authContext = requiresAdal ? new AuthenticationContext(adalConfig) : null

export function authenticateToken() {
  if (authContext.getCachedUser()) {
    // If we have a cached login, use it
    return true
  }

  if (authContext.isCallback(window.location.hash)) {
    // This happens after the AD login screen,
    // handleWindowCallback will use the hash to
    // complete the login
    authContext.handleWindowCallback()
    return true
  }

  // Not logged in
  return false
}



// WEBPACK FOOTER //
// ./src/js/adalAuth.js